import { render, staticRenderFns } from "./PayabelRateArchiving.vue?vue&type=template&id=552e85be&scoped=true"
import script from "./PayabelRateArchiving.vue?vue&type=script&lang=js"
export * from "./PayabelRateArchiving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e85be",
  null
  
)

export default component.exports